import { mix } from 'polished'
import styled from 'styled-components'

import { ProductLogo } from '@subaio/components'
import { simpleHash } from '@subaio/utils'

import { helpers } from 'styles'

const colors = ['#0000FF', '#EA6519', '#2793FF', '#BA2B65', '#8C30F0', '#BB7F6F', '#30A2A9']

export const Logo = styled(ProductLogo).attrs(({ title, size = 40 }) => ({
	border: false,
	background: title ? mix(0.8, '#FFF', colors[simpleHash(title, colors.length)]) : undefined,
	size,
}))`
	flex-shrink: 0;
	color: ${({ title, theme }) => (title ? colors[simpleHash(title, colors.length)] : theme.color.textContrast)};
	font-size: ${helpers.font.size.base};
`
